import { Icon } from '@iconify/react';
import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import React, { useState } from 'react';
import { updateEstadoEnvio } from '../../../../../_apis_/dagpacket-oneRequest';

function BtnActualizarEnvio({ idEnvio }) {
  const [loading, setLoading] = useState(false);
  const handleUpdateGua = async () => {
    setLoading(true);
    try {
      await updateEstadoEnvio(idEnvio);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <LoadingButton
      onClick={handleUpdateGua}
      loading={loading}
      variant="contained"
      color="warning"
      startIcon={<Icon icon="material-symbols:refresh" />}
    >
      Actualizar Guia
    </LoadingButton>
  );
}

export default BtnActualizarEnvio;
